import { Component, OnDestroy, OnInit } from "@angular/core";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { EnvService } from "gematik-form-library";
import { Alert, PortalService } from "gematik-shared";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "data-privacy",
  styleUrls: ["data-privacy.component.scss"],
  template: `
    <gem-header [showQuickAction]="false"></gem-header>
    <div class="container mt-0" style="--bs-gutter-x: 0; --bs-gutter-y: 0">
      <gematik-alerts [alerts]="alerts$ | async"></gematik-alerts>
    </div>
    <div class="row mt-3 mb-2 gib-flex-center text--large">
      <div class="col-sm-12 form-width">
        <div class="row">
          <div class="col-sm-12">
            <div class="d-flex justify-content-between mt-3">
              <h1>
                <span>{{ "portal.dataPrivacy.title" | translate }}</span>
              </h1>
            </div>
          </div>
        </div>
        <hr />

        <div class="row">
          <div class="col-sm-12">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ "portal.dataPrivacy.1.title" | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <data-privacy-section-1></data-privacy-section-1>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title
                    >{{ "portal.dataPrivacy.2.title" | translate }} Portals</mat-panel-title
                  >
                </mat-expansion-panel-header>
                <data-privacy-section-2></data-privacy-section-2>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ "portal.dataPrivacy.3.title" | translate }}</mat-panel-title>
                </mat-expansion-panel-header>
                <data-privacy-section-3></data-privacy-section-3>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </div>

    <gem-footer></gem-footer>
  `,
  standalone: false,
})
export class DataPrivacyComponent implements OnInit, OnDestroy {
  lang: string;
  alerts$: Observable<Alert[]>;
  subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private env: EnvService,
    private portalService: PortalService,
  ) {}

  ngOnInit(): void {
    this.alerts$ = this.portalService.getAlerts(this.env.backendUrl, "UWL");
    this.translate
      .get(`languages.${this.translate.currentLang === "en" ? "de" : "en"}`)
      .subscribe((res: string) => {
        this.lang = res;
      })
      .unsubscribe();

    const langSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translate
        .get(`languages.${event.lang === "en" ? "de" : "en"}`)
        .subscribe((res: string) => {
          this.lang = res;
        })
        .unsubscribe();
    });
    this.subscriptions.push(langSub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
